<template>
  <main>
    <b-card border-variant="light">
      <div class="card-text">
        <div class="d-block">
          <span class="h6 font-weight-bold">Råd og vejledning</span>
        </div>
        <span class="d-block mt-4">
          <b-btn variant="success" @click="guideShow = !legalShow">Åbn dokumentet</b-btn>
        </span>
        <!-- Modal Component -->
        <b-modal id="modal-center" ref="guideModal" lazy v-model="guideShow" header="Råd og vejledning" size="lg">
          <!-- modalHeader -->
          <div slot="modal-header" class="pb-0">
            <div class="h5 pt-2 pb-2 pl-2 font-weight-bold">Råd og vejledning</div>
          </div>
          <!-- modalBody -->
          <p class="h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden">
            For at sikre at du som partner får mest muligt ud af dit partnerskab, har vi her udarbejdet en vejledning til din brug af vores service.
            <br><br>
            Vejledningen forklarer den generelle brug af vores service. Vejledningen indeholder også en rådgivning om, hvordan kontakten med kunden bør foregå for at få det bedste resultat og størst udbytte ud af vores service.
            <br><br>
            Når du følger denne vejledning, øges chancerne betydeligt for, at et kundemøde bliver til en ordre.
            <br><br>
          </p>
          <p class="h5 text-dark pt-2 pb-2 pl-2 line-height-golden font-weight-bold">Kundemøder</p>
          <p class="h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden">
            For at sikre at du som partner får mest muligt ud af dit partnerskab, har vi her udarbejdet en vejledning til din brug af vores service.
            <br><br>
            Vejledningen forklarer den generelle brug af vores service. Vejledningen indeholder også en rådgivning om, hvordan kontakten med kunden bør foregå for at få det bedste resultat og størst udbytte ud af vores service.
            <br><br>
            Når du følger denne vejledning, øges chancerne betydeligt for, at et kundemøde bliver til en ordre.
            <br><br>
          </p>
          <p class="h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden">
            <ul class="pl-4">
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Ring kunden op: </strong>Sørg altid for at ringe til kunden umiddelbart efter, at du har modtaget kontaktoplysninger og opgavebeskrivelse, for at præsentere dig selv. Det giver kunden et godt førstehåndsindtryk og en følelse af tryghed i processen. Det giver også jer begge en mulighed for at forberede jer på mødet og afstemme forventninger.
              </li>
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Giv besked: </strong>Giv altid kunden personlig besked, hvis du bliver forhindret eller forsinket.
              </li>
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Spørg ind og lyt: </strong>Husk at spørge grundigt ind til kundens behov, og lyt godt efter, når kunden forklarer - det får kunden til at føle sig godt tilpas, og det fører samtidig til de mest præcise tilbud.
              </li>
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Vis eksempler: </strong>Vis gerne eksempler på tidligere/lignende opgaver, du har løst - vi oplever generelt, at billedeksempler i høj grad øger chancerne for at få ordren hjem.
              </li>
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Sammensæt et godt tilbud: </strong>Send kunden et godt, seriøst og gennemarbejdet skriftligt tilbud, der er konkurrencedygtigt.
              </li>
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Send tilbuddet hurtigst muligt: </strong>Send tilbuddet hurtigst muligt og senest en uge efter mødet.
              </li>
            </ul>
          </p>
          <p class="h5 text-dark pt-2 pb-2 pl-2 line-height-golden font-weight-bold">Opfølgning efter mødet</p>
          <p class="h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden">
            Vi oplever, at en vis andel af kunder, ikke selv ringer tilbage for at følge op på tilbuddet. Oftest betyder dette ikke nødvendigvis, at de er afvisende overfor tilbuddet - mange kunder vil derimod typisk vente på, at du selv tager kontakt til dem igen.
            <br><br>
            Vi anbefaler derfor, at du selv følger op på mødet og tilbuddet på følgende måde:
            <br><br>
          </p>
          <p class="h6 text-dark open-sans pr-4 pb-0 pl-4 line-height-golden">
            <ul class="pl-4">
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Ring til kunden dagen efter, du har sendt tilbuddet.</strong>Du kan evt. forklare, at du ringer for at sikre dig, at kunden har modtaget tilbuddet. Tilbyd evt. også at gennemgå tilbuddet skridt for skridt sammen med kunden for at klargøre indholdet.
              </li>
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Ring til kunden igen en uge efter, du har sendt tilbuddet, for at følge op på det</strong>- evt. ved at spørge, hvad kunden synes om tilbuddet, og om han/hun har nogen spørgsmål.
              </li>
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Spørg ind og lyt: </strong>Husk at spørge grundigt ind til kundens behov, og lyt godt efter, når kunden forklarer - det får kunden til at føle sig godt tilpas, og det fører samtidig til de mest præcise tilbud.
              </li>
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Vis eksempler: </strong>Vis gerne eksempler på tidligere/lignende opgaver, du har løst - vi oplever generelt, at billedeksempler i høj grad øger chancerne for at få ordren hjem.
              </li>
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Sammensæt et godt tilbud: </strong>Send kunden et godt, seriøst og gennemarbejdet skriftligt tilbud, der er konkurrencedygtigt.
              </li>
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Send tilbuddet hurtigst muligt: </strong>Send tilbuddet hurtigst muligt og senest en uge efter mødet.
              </li>
            </ul>
          </p>
          <p class="h5 text-dark pt-2 pb-2 pl-2 line-height-golden font-weight-bold">Accept af tilbud og aftaler med kunden</p>
          <p class="h6 text-dark open-sans pr-4 pb-0 pl-4 line-height-golden">
            <ul class="pl-4">
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Få altid en skriftlig accept fra kunden inden arbejdet startes.</strong> Den skriftlige aftale bør som minimum omfatte prisen på opgaven og en klar beskrivelse af opgavens omfang.
              </li>
              <li class="pb-3">
                <strong class="text-dark font-weight-bold headerfont">Få en økonomisk sikkerhedsstillelse fra kunden umiddelbart efter ordrens accept.</strong>
              </li>
            </ul>
          </p>
          <p class="h5 text-dark pt-2 pb-2 pl-2 line-height-golden font-weight-bold">Generelt om din brug af vores service</p>
          <p class="h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden">
            <strong class="text-dark font-weight-bold headerfont">Partnerlogin:</strong>
            <br>Prisberegning.dk's partnerside på prisberegning.dk skal benyttes til at administrere dit partnerskab. Det vil bl.a. sige, at alle aflysninger og reklamationer skal ske gennem din personlige partnerprofil. Du modtager en mail med loginoplysninger til partnerprofilen ved oprettelsen.
          </p>
          <p class="h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden">
            <strong class="text-dark font-weight-bold headerfont">Ferie:</strong>
            <br>Holder du ferie/lukket, så skal dette indberettes til iMentor, hvis dit partnerskab skal sættes i bero (ikke relevant, hvis du udelukkende er SMS-partner). Hvis der allerede er booket et møde ind til afholdelse i din ferieperiode, så skal du selv sørge for at flytte det. Dit partnerskab kan sættes i bero i 6 uger årligt.
          </p>
          <p class="h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden">
            <strong class="text-dark font-weight-bold headerfont">Aflysninger:</strong>
            <br>Aflysninger skal indberettes senest på det planlagte afholdelsestidspunkt via din partnerprofil.
          </p>
          <p class="h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden">
            <strong class="text-dark font-weight-bold headerfont">Reklamationer:</strong>
            <br>Reklamationer skal indberettes senest dagen efter mødets afholdelse via din partnerprofil.
          </p>
          <p class="h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden">
            <strong class="text-dark font-weight-bold headerfont">Din balance på partnerprofilen:</strong>
            <br>Når aflysningen/reklamationen er behandlet og godkendt, så tilbageføres betalingen for mødet automatisk til din balance. Betalingen for dit næste møde trækkes fra denne balance. Du kan få overblik over din balance på din personlige partnerprofil.
          </p>
          <p class="h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden">
            <strong class="text-dark font-weight-bold headerfont">Flytning af møde:</strong>
            <br>Hvis du aftaler med kunden at flytte mødet til et andet tidspunkt, skal du indberette dette via din partnerprofil, da mødetidspunktet har indflydelse på tidsfrister for aflysninger og reklamationer.
          </p>
          <!-- modalFooter -->
          <div slot="modal-footer" class="w-100 mt-0 pt-0 pr-4 pb-4 pl-4">
            <b-btn type="reset" slot="modal-cancel" variant="primary" size="lg" class="float-right" @click="closeGuideModal">
              <span class="el-icon-error mr-2"></span>Luk</b-btn>
          </div>
        </b-modal>
      </div>
    </b-card>
  </main>
</template>
<script>
export default {
  name: 'textvejledning',
  data () {
    return {
      guideShow: false
    }
  },
  methods: {
    closeGuideModal () {
      this.$refs.guideModal.hide()
    }
  }
}
</script>
<style scoped>
.modal-header {
  padding-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// textVejledning.vue?952267fa